<template>
  <div class="noticias">
    <b-container class="noticia" v-loading="loading">
      <div class="noticia-title">
        <h3>{{ noticia.titulo }}</h3>
      </div>
      <div class="noticia-date pb-3" v-if="noticia.data">
        {{ noticia.data | formatDate("LL") }}
      </div>
      <div class="noticia-body">
        <div class="noticia-body__images">
          <img :key="noticia.id" :src="noticia.capa" alt="" />
        </div>
        <div class="noticia-body__texto text-justify">
          <div v-html="noticia.texto"></div>
          <div class="noticia-body__images">
          <img
            v-for="(item, index) in noticia.images"
            :key="index"
            :src="item.image"
            class="img"
          />
        </div>
          <div class="noticia-body__fontes">
            <span class="text-font" v-if="noticia.fonte"
              >Fonte: {{ noticia.fonte }}</span
            >
            <span v-if="noticia.creditos" class="text-font"
              >Crédito das Fotos: {{ noticia.creditos }}</span
            >
          </div>
          <div
            class="medias-share"
            v-if="Object.keys(noticia).length > 0 && url.length > 1"
          >
            <ShareNetwork
              network="whatsapp"
              :url="url"
              :title="noticia.titulo"
              description=""
              quote=""
              hashtags=""
              :media="url"
            >
              <img
                class="network"
                src="../assets/images/whats.png"
                alt=""
              />
            </ShareNetwork>
            <ShareNetwork
              network="facebook"
              :url="url"
              :title="noticia.titulo"
              description=""
              quote=""
              hashtags=""
              :media="url"
            >
              <img
                class="network"
                src="../assets/images/fb1.png"
                alt=""
              />
            </ShareNetwork>
          </div>
        </div>
      </div>
    </b-container>
    <div class="list" v-loading="loadingDestaque">
      <Lista :destaque="destaque" @showId="showId" />
      <!-- <router-link to="/noticias" class="text-right">
        <small class="all">Todas as notícias</small>
      </router-link> -->
      <div class="see-all">
        <a href="/noticias" class="text-right"
          ><span class="all-links">Todas</span></a
        >
      </div>
    </div>
  </div>
</template>

<script>
import Lista from "@/components/destaque/Lista";
export default {
  name: "noticias",
  components: {
    Lista,
  },
  data() {
    return {
      noticia: {},
      destaque: [],
      loading: false,
      loadingDestaque: false,
      url: "",
    };
  },
  methods: {
    async getDestaques() {
      this.loadingDestaque = true;
      const res = await this.$axios.get("noticias").catch((e) => {
        console.error("noticias", e);
      });
      if (res.status === 200) {
        this.destaque = res.data.data;
      }
      this.loadingDestaque = false;
    },
    showId(id) {
      if (id.toString() === this.$route.params.id.toString()) return;
      this.toShow = this.destaque.filter((item) => item.id === id)[0];
      this.getPage(id, this.slugify(this.toShow.titulo));
    },
    slugify(text) {
      return text
        .toString()
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-")
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-");
    },
    getPage(id, title) {
      // this.$router.push(`${`/noticia/${id}/${title}`}`);
      this.$router.push({
        path: `${`/noticia/${id}/${title}`}`,
        replace: true,
      });
    },
    async getNoticia(id) {
      this.loading = true;
      this.noticia = [];
      //const id = this.$route.params.id;
      const res = await this.$axios.get(`noticias/${id}`).catch((e) => {
        console.error("Noticia", e);
      });
      if (res.status === 200) {
        this.noticia = res.data;
      }
      this.loading = false;
    },
  },
  mounted() {
    this.url = `http://ressoarte.sistemaweb.com.br${window.location.pathname}`;
    this.getNoticia(this.$route.params.id);
    this.getDestaques();
  },
  beforeRouteUpdate(to, from, next) {
    this.getNoticia(to.params.id);
    next();
  },
};
</script>

<style lang="scss">
.noticias {
  display: flex;
  padding: 0 20px;
  font-size: var(--font-size--large);
  .network {
    padding-left: 10px;
    margin-bottom: 10px;
    height: 25px;
    width: 33px;
  }
  .noticia {
    padding-top: 20px;
    &-body {
      display: flex;
      flex-direction: column;
      &__images {
        display: flex;
        flex-direction: column;
        height: 100%;
        img {
          height: auto;
          width: 100%;
          object-fit: cover;
          padding: 20px;
        }
      }
      &__fontes {
        display: flex;
        flex-direction: column;
        margin: 15px 0;
      }
    }
  }
  .list {
    width: 40%;
    display: flex;
    flex-direction: column;
    background-color: var(--background-color-light);
    height: 100%;
    padding-bottom: 20px;
    .lista {
      height: auto;
      text-align: left;
    }
    .see-all {
      display: flex;
      justify-content: flex-end;
      padding: 0 24px 0 0;
    }
    .text-right {
      width: 112px;
      height: 30px;
      background-color: var(--color-text-title);
      color: #ffffff;
      border-radius: 5px;
      align-items: center;
      justify-content: center;
      display: flex;
      &:active,
      &:hover {
        background-color: #4d66bf !important;
        text-decoration: none;
      }
    }
  }
}
@media only screen and (max-width: 936px) {
  .noticias {
    .noticia {
      padding-top: 20px;
      &-body {
        display: flex;
        flex-direction: column;
        &__images {
          display: flex;
          flex-direction: column;
          height: 100%;
          img {
            height: auto;
            width: 100%;
            object-fit: cover;
            padding: 5px;
          }
        }
      }
    }
    .list {
      display: none;
    }
  }
}

@media only screen and (max-width: 425px) {
  .noticia {
    &-body {
      &__texto {
        img {
          width: 100%;
          height: auto;
        }
      }
    }
  }
}
.img {
  width: 50% !important;
}

.noticia-body__images{
  display: flex;
    justify-content: space-between;
    flex-direction: row !important;
    flex-wrap: wrap;
}
</style>
